// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const MORE = "Viac";
export const STROLLERS_SEARCH_HOMEPAGE_BTN_TITLE = "N\u00e1jdi ko\u010d\u00edk pod\u013ea svojich predst\u00e1v";
